import { Provider, signal } from '@angular/core';

import { ATTENTION_PROJECTIONS, AttentionProjection } from '@shared/services/attention/attention-projections';

/** The rail items invoicing's badges decorate — the pages-config urls of its children. */
export const INVOICING_RAIL = {
  invoices: '/provider/app/invoicing/invoices',
  approvals: '/provider/app/invoicing/approvals',
} as const;

/* What the invoicing store last counted, published here so the ROOT projection reads it without
   importing the store — which would pull invoicing into the app's initial chunk (the 7 MB budget,
   M2; the restaurant's, the salon's and the grocery's pattern). Until invoicing has been opened this
   session there is nothing counted, and no badge. */
const OVERDUE = signal(0);
const PENDING = signal(0);

/** The store's one write — what is overdue, and what waits for a second signature. */
export function publishInvoicingBadges(overdue: number, pending: number): void {
  if (OVERDUE() !== overdue) OVERDUE.set(overdue);
  if (PENDING() !== pending) PENDING.set(pending);
}

/**
 * Invoicing's rail badges (batch 5 V0, D402): *Invoices* carries the overdue count, by the DATE
 * (D403) — the core list is never gated; *Approve* carries what waits for a second signature (D405),
 * the same list the screen shows.
 */
export function invoicingAttentionProjections(): readonly AttentionProjection[] {
  return [
    {
      rule: { id: 'invoicing.core.overdue', moduleId: 'invoicing', capKey: null, railItemId: INVOICING_RAIL.invoices, enabled: true, scope: 'site' },
      count: OVERDUE.asReadonly(),
    },
    {
      rule: { id: 'invoicing.approvals.pending', moduleId: 'invoicing', capKey: 'approvals', railItemId: INVOICING_RAIL.approvals, enabled: true, scope: 'site' },
      count: PENDING.asReadonly(),
    },
  ];
}

/** Register invoicing's projections at the root (AppModule), so the shell can show them. */
export function provideInvoicingAttention(): Provider[] {
  return [{ provide: ATTENTION_PROJECTIONS, useValue: invoicingAttentionProjections, multi: true }];
}
